query getFootballScores {
    getFootballScores
}
